import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Form, Select } from "antd";
import { FormServiceLayout } from "../..";
import { useFormService, useI18n } from "../../../../contexts";
import { Notices } from "../../../common";
const FormServiceFieldCreateContentBlocker = ()=>{
    const { __ } = useI18n();
    const { template, isEdit, essentialGroupId, allowContentBlockerCreation, contentBlockerTemplates } = useFormService();
    return allowContentBlockerCreation && !isEdit && (contentBlockerTemplates == null ? void 0 : contentBlockerTemplates.length) > 0 && /*#__PURE__*/ _jsxs(Form.Item, {
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span
        },
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.group !== nextValues.group,
                children: (param)=>{
                    let { getFieldValue } = param;
                    return /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        name: "createContentBlocker",
                        valuePropName: "checked",
                        dependencies: [
                            "group"
                        ],
                        rules: [
                            {
                                validator: (_, value)=>getFieldValue("group") === essentialGroupId && value ? Promise.reject(__('Services that should be associated with a content blocker cannot be in the "Essential" group, because it cannot be rejected.')) : Promise.resolve()
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            children: __("Create content blocker for this service.")
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.createContentBlocker !== nextValues.createContentBlocker,
                children: (param)=>{
                    let { getFieldValue } = param;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getFieldValue("createContentBlocker") && /*#__PURE__*/ _jsx(_Fragment, {
                                children: contentBlockerTemplates.length > 1 && /*#__PURE__*/ _jsx(Form.Item, {
                                    noStyle: true,
                                    name: "createContentBlockerId",
                                    rules: [
                                        {
                                            required: true,
                                            message: __("Please select a template for the Content Blocker!")
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Select, {
                                        style: {
                                            maxWidth: 500,
                                            marginTop: 10,
                                            display: "block"
                                        },
                                        placeholder: __("Select Content Blocker template..."),
                                        children: contentBlockerTemplates.map((param)=>{
                                            let { identifier, name, subHeadline } = param;
                                            return /*#__PURE__*/ _jsx(Select.Option, {
                                                value: identifier,
                                                children: `${name}${subHeadline && name.indexOf(subHeadline) === -1 ? ` (${subHeadline})` : ""}`
                                            }, identifier);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Notices, {
                                notices: [
                                    {
                                        message: getFieldValue("createContentBlocker") ? __("Immediately after submitting this form you will be forwarded to another form that allows you to create the Content Blocker.") : undefined,
                                        severity: "info"
                                    },
                                    {
                                        message: template == null ? void 0 : template.createContentBlockerNotice,
                                        severity: "info"
                                    }
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
export { FormServiceFieldCreateContentBlocker };
